import { Component } from '@angular/core';

@Component({
  selector: 'app-side-bar-mentor-stemd',
  templateUrl: './side-bar-mentor-stemd.component.html',
  styleUrls: ['./side-bar-mentor-stemd.component.css'],
})
export class SideBarMentorStemdComponent {
  urlScholarVox = 'https://skills.scholarvox.com/forcen';

  openUrl(url: string) {
    window.open(url, '_blank');
  }
}
